module.exports = __webpack_public_path__ + "static/media/gc-menthe-solo.4df2afa3.png";